import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import type { UserPlan } from '@/contexts/UserContext';
import { planDefinitions } from '@/config/planData';

interface StripePriceInfo {
  price_id: string;
  unit_amount: number;
  currency: string;
}

export interface StripePrices {
  pro?: StripePriceInfo;
  avancado?: StripePriceInfo;
}

const formatPrice = (amount: number) =>
  `R$ ${(amount / 100).toFixed(2).replace('.', ',')}`;

export function usePlanPrices() {
  const [prices, setPrices] = useState<StripePrices>({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    supabase.functions.invoke('stripe-prices', { method: 'GET' }).then(({ data, error: err }) => {
      if (data && !err && !data.error) {
        setPrices(data);
      } else {
        setError(true);
      }
      setLoading(false);
    });
  }, []);

  const getPrice = (key: UserPlan): string => {
    const plan = planDefinitions.find(p => p.key === key);
    if (!plan || !plan.lookupKey) return 'Grátis';
    if (loading) return '...';
    const p = key === 'pro' ? prices.pro : prices.avancado;
    if (p) return `${formatPrice(p.unit_amount)}/mês`;
    return error ? 'Erro ao carregar' : '...';
  };

  const getPriceId = (key: UserPlan): string | undefined => {
    if (key === 'pro') return prices.pro?.price_id;
    if (key === 'avancado') return prices.avancado?.price_id;
    return undefined;
  };

  return { prices, loading, error, getPrice, getPriceId };
}
